import {
  Component,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IYuzBbox } from '@/src/app/shared/interfaces/yuz.interfaces';
import { bboxCropStili } from '@/src/app/shared/utils/bbox.utils';

export type { IYuzBbox } from '@/src/app/shared/interfaces/yuz.interfaces';

@Component({
  selector: 'yuz-crop',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div class="yc-wrap" [style]="stilHesapla()"></div>
  `,
  styles: [`
    :host { display: inline-block; }

    .yc-wrap {
      border-radius: 50%;
      background-repeat: no-repeat;
      overflow: hidden;
    }
  `],
})
export class YuzCropComponent {
  readonly resimUrl = input.required<string>();
  readonly bbox = input.required<IYuzBbox>();
  readonly boyut = input(36); // px
  readonly yuvarlak = input(true);

  stilHesapla(): string {
    return bboxCropStili(this.resimUrl(), this.bbox(), this.boyut(), this.yuvarlak());
  }
}
